<div class="success-wrapper">
    <div class="success-container">
        <div class="success-content">
            <!-- Success Icon with Animation -->
            <div class="success-icon-wrapper">
                <div class="success-icon-circle">
                    <svg class="success-checkmark" width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="10" stroke="#10B981" stroke-width="2" fill="#D1FAE5"/>
                        <path d="M8 12L11 15L16 9" stroke="#10B981" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </div>

            <!-- Success Title -->
            <div class="success-title">
                <h2 class="success-title-text">{{ message }}</h2>
            </div>

            <!-- Success Message -->
            <div class="success-message">
                <p class="success-message-text">
                    You will be redirected to the login page in 
                    <span class="countdown-number">{{ countdown }}</span> 
                    <span class="countdown-text">{{ countdown === 1 ? 'second' : 'seconds' }}</span>.
                </p>
                <p class="success-message-subtext">
                    If you are not redirected automatically, please click the button below.
                </p>
            </div>

            <!-- Redirect Button -->
            <div class="success-actions">
                <button class="success-button" (click)="redirectNow()">
                    <span>Go to Login</span>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
            </div>
        </div>
    </div>
</div>